<div class="">
  <h1 *ngIf="title">{{ title }}</h1>

  <ng-content *ngIf="!title" select="[title]"></ng-content>

  <ng-content select="[metadata]"></ng-content>

  <h5 *ngIf="message" [innerHtml]="message" class="mt-10 pl-6 pr-6"></h5>

  <div class="p-2">
    <span class="self-end" *ngIf="contentDescription">
      {{ contentDescription }}
    </span>

    <div *ngIf="showTopButtons" class="footer flex justify-end pt-2">
      <div class="footer flex justify-end">
        <ng-content select="[prepend-buttons-top]"></ng-content>
        <thera-button *ngIf="!hideSave" (clicked)="onSaveClicked()" [disabled]="saveDisabled"
          [config]="saveBtnConfig"></thera-button>
      </div>
    </div>
  </div>

  <div class="mb-5"><ng-content select="[content]"></ng-content></div>

  <div *ngIf="showBottomButtons" class="footer pt-2 flex justify-end flex-wrap">
    <ng-content select="[prepend-buttons]"></ng-content>
    
    <div *ngIf="isNewEntity">
      <thera-button class="pr-2" [config]="{ variant: buttonVariant.SECONDARY_OUTLINE, text: 'Cancel' }"
        (click)="onCancelClicked()"></thera-button>
    </div>

    <thera-button
      *ngIf="!hideSave"
      (click)="onSaveClicked()"
      [disabled]="saveDisabled"
      [config]="saveBtnConfig"
    ></thera-button>

    <ng-content select="[append-buttons]"></ng-content>
  </div>
</div>
